export const sortByIsPause = (a, b) => {
  // If 'is_pause' key is not present in any entry, consider it as false
  const isPauseA =
    a.is_paused === undefined ? false : a.is_paused == 0 ? false : true;
  const isPauseB =
    b.is_paused === undefined ? false : b.is_paused == 0 ? false : true;
  // Items without 'is_pause' should come first
  if (isPauseA === false && isPauseB !== false) {
    return -1;
  } else if (isPauseA !== false && isPauseB === false) {
    return 1;
  } else {
    return 0;
  }
};

export const objectToQueryParams = (obj) => {
  const queryParams = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key]) {
      queryParams.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
      );
    }
  }

  if (queryParams.length > 0) {
    return `?${queryParams.join("&")}`;
  }

  return "";
};
